module.exports = __webpack_public_path__ + "img/content_make11.ceb84995.png";